import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { VENDOR_FILE_REJECT_API_URL } from '../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { fileRejectFailure, fileRejectSuccess } from '../actions';

const fileRejectAPI = (action) => postApiRequest(VENDOR_FILE_REJECT_API_URL, action);

function* handleFileReject(action) {
  try {
    const response = yield call(fileRejectAPI, action.payload);
    if (response?.data?.success && response?.data?.resultMessage !== '') {
      toast.success(response?.data?.resultMessage);
    }
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(fileRejectSuccess(response));
  } catch (error) {
    yield put(fileRejectFailure(error));
  }
}

export function* watchFileRejct() {
  yield takeLatest(types.FILE_REJECT_REQUEST, handleFileReject);
}
